/**
 * @desc saleTransferOrderTx
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.SaleTransferOrderTxRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationBatch/saleTransferOrderTx`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
